export default __webpack_public_path__ + "images/image08.jpg";